var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.showAssets),function(item,index){return _c('asset-item',_vm._g({key:index,attrs:{"asset":item}},_vm.$listeners))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }